import React from 'react';

import Row from '../components/row';
import Title from '../components/title';

const ContactForm = () => {
  return (
      <Row>
        <Title title="Formulario de Contacto" />
        <form role="form" action="mailto:elcapullohotel@gmail.com" enctype="text/plain">
          <input style={{display: 'none'}} name="subject" value="Consulta"/>
          <div className="container">
            <div className="row">
              <div className="form-group col-lg-5 col-lg-offset-1 col-md-5 col-sm-5 col-sm-offset-1 col-md-offset-1">
                <div className="from-group mt30 text-center">
                  <div className="input-group">
                    <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                    <input placeholder="NOMBRE"  className="form-control" type="text" />
                  </div>
                </div>
              <div className="form-group mt30 text-center">
                <div className="input-group">
                  <span className="input-group-addon"><i className="glyphicon glyphicon-envelope"></i></span>
                  <input placeholder="EMAIL" className="form-control" type="text" />
                </div>
              </div>
              <div className="form-group mt30 text-center">
                <div className="input-group">
                  <span className="input-group-addon"><i className="glyphicon glyphicon-earphone"></i></span>
                  <input placeholder="TELÉFONO" className="form-control" type="text" />
                </div>
              </div>
            </div>
            <div className="form-group col-lg-5 col-md-5 col-sm-5 mt30 text-center">
              <div className="input-group">
                <span className="input-group-addon"><i className="glyphicon glyphicon-comment"></i></span>
                <textarea className="form-control" style={{height: '164px'}} rows="6"></textarea>
              </div>
            </div>
              <div className="form-group col-lg-12 text-center">
                <button type="submit" className="btn btn-info">Enviar <span className="glyphicon glyphicon-send"></span></button>
              </div>
          </div>
          </div>
        </form>
      </Row>
  );
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/contact/contact-form.js